import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {

    return (
        <div className='loading-page d-flex'>
            <div className={`d-flex align-items-center justify-content-center w-100`}>
                <div className={`card message-card w-75`}>
                    <div className="card-body text-center p-5">
                        <h2>Loading</h2>
                        <p>We will let you in shortly</p>
                        <div className="spinner-border text-info ml-auto" role="status">
                            <span className="sr-only"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingScreen;
